var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.sendData.id ? _vm.$t("modify") : _vm.$t("submit"),
            visible: _vm.dialogShow,
            modal: false,
            "close-on-click-modal": false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.sendData,
                "label-width": "80px"
              }
            },
            [
              _c(
                "div",
                { staticClass: "content_ValClass" },
                [
                  _c(
                    "div",
                    { staticClass: "lodingItem-operationFrame flex" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem contentValitem",
                          attrs: {
                            prop: "sender",
                            label: _vm.$t("sender"),
                            "label-width": "80px"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "operationFrame-entity",
                            attrs: { placeholder: _vm.$t("emailSender") },
                            model: {
                              value: _vm.sendData.sender,
                              callback: function($$v) {
                                _vm.$set(_vm.sendData, "sender", $$v)
                              },
                              expression: "sendData.sender"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem contentValitem",
                          attrs: {
                            prop: "title",
                            label: _vm.$t("emailTitle"),
                            "label-width": "90px"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "operationFrame-entity",
                            attrs: {
                              clearable: "",
                              placeholder: _vm.$t("pleaseEnterEmailTitle")
                            },
                            model: {
                              value: _vm.sendData.title,
                              callback: function($$v) {
                                _vm.$set(_vm.sendData, "title", $$v)
                              },
                              expression: "sendData.title"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "lodingItem-operationFrame flex" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem contentValitem",
                          attrs: {
                            prop: "language",
                            label: _vm.$t("language"),
                            "label-width": "80px"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "operationFrame-entity",
                              attrs: { placeholder: _vm.$t("pleaseSelect") },
                              model: {
                                value: _vm.sendData.language,
                                callback: function($$v) {
                                  _vm.$set(_vm.sendData, "language", $$v)
                                },
                                expression: "sendData.language"
                              }
                            },
                            _vm._l(_vm.Language, function(item) {
                              return _c("el-option", {
                                key: item.label,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem contentValitem",
                          attrs: {
                            prop: "expire",
                            label: _vm.$t("expireTime"),
                            "label-width": "90px"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticClass: "operationFrame-entity",
                            attrs: {
                              "popper-class": "no-atTheMoment",
                              clearable: false,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetime",
                              placeholder: _vm.$t("date")
                            },
                            model: {
                              value: _vm.sendData.expire,
                              callback: function($$v) {
                                _vm.$set(_vm.sendData, "expire", $$v)
                              },
                              expression: "sendData.expire"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "flex lodingItem-title first_box",
                      staticStyle: {
                        "margin-bottom": "20px",
                        width: "100%",
                        "align-items": "center"
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("emailContent")) + ": "),
                      _c(
                        "div",
                        {
                          staticClass: "flex",
                          staticStyle: { "padding-left": "20px" }
                        },
                        _vm._l(_vm.tagList, function(items, indexs) {
                          return _c(
                            "div",
                            {
                              key: indexs,
                              staticClass: "addtag",
                              on: {
                                click: function($event) {
                                  return _vm.addtag(items.contents, _vm.index)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(items.name) + " ")]
                          )
                        }),
                        0
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { prop: "contents" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 12 },
                          placeholder: _vm.$t("pleaseEnterEmailContent")
                        },
                        model: {
                          value: _vm.sendData.contents,
                          callback: function($$v) {
                            _vm.$set(_vm.sendData, "contents", $$v)
                          },
                          expression: "sendData.contents"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addDomain }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("addRole")) + " ")]
                  )
                ],
                1
              ),
              _vm._l(_vm.sendData.desc, function(domain, index) {
                return _c(
                  "div",
                  { key: index, staticStyle: { width: "100%" } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              placeholder: _vm.$t("pleaseChoose")
                            },
                            on: {
                              change: function($event) {
                                return _vm.envIdChange(index)
                              }
                            },
                            model: {
                              value: domain.env_id,
                              callback: function($$v) {
                                _vm.$set(domain, "env_id", $$v)
                              },
                              expression: "domain.env_id"
                            }
                          },
                          _vm._l(_vm.szgmEnv, function(item) {
                            return _c("el-option", {
                              key: item.label,
                              attrs: { label: item.label, value: item.id }
                            })
                          }),
                          1
                        ),
                        _c(
                          "el-select",
                          {
                            staticStyle: { margin: "20px 40px" },
                            attrs: {
                              filterable: "",
                              placeholder: _vm.$t("serverChannel"),
                              clearable: ""
                            },
                            on: { change: _vm.serverChange },
                            model: {
                              value: domain.server_channel,
                              callback: function($$v) {
                                _vm.$set(domain, "server_channel", $$v)
                              },
                              expression: "domain.server_channel"
                            }
                          },
                          _vm._l(domain.serverChannel, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        ),
                        _c(
                          "el-select",
                          {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: _vm.$t("showTestServer")
                            },
                            on: {
                              change: function($event) {
                                return _vm.serverChannelChange(index)
                              }
                            },
                            model: {
                              value: domain.show_test,
                              callback: function($$v) {
                                _vm.$set(domain, "show_test", $$v)
                              },
                              expression: "domain.show_test"
                            }
                          },
                          _vm._l(_vm.serverType, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c(
                          "el-form-item",
                          {
                            key: "server_id",
                            staticClass: "lodingItem",
                            staticStyle: { "margin-right": "10px" },
                            attrs: {
                              prop: "desc." + index + ".server_id",
                              rules: _vm.rules.server_id,
                              label: _vm.$t("server"),
                              "label-width": "80px"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "operationFrame-entity",
                                attrs: {
                                  filterable: "",
                                  clearable: "",
                                  placeholder: _vm.$t("pleaseSelect")
                                },
                                model: {
                                  value: domain.server_id,
                                  callback: function($$v) {
                                    _vm.$set(domain, "server_id", $$v)
                                  },
                                  expression: "domain.server_id"
                                }
                              },
                              _vm._l(domain.serverListYJ, function(item) {
                                return _c("el-option", {
                                  key: item.serverID,
                                  attrs: {
                                    label: item.serverName,
                                    value: item.serverID
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            key: "role_id",
                            staticClass: "lodingItem",
                            attrs: {
                              prop: "desc." + index + ".role_id",
                              rules: _vm.rules.role_id,
                              label: _vm.$t("roleId")
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "operationFrame-entity",
                              attrs: { placeholder: _vm.$t("roleId") },
                              model: {
                                value: domain.role_id,
                                callback: function($$v) {
                                  _vm.$set(domain, "role_id", _vm._n($$v))
                                },
                                expression: "domain.role_id"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem marginL",
                            staticStyle: { width: "200px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "controlsItem" },
                              [
                                _vm.sendData.desc.length > 1
                                  ? _c("el-button", {
                                      staticStyle: { margin: "6px 0 6px 20px" },
                                      attrs: {
                                        size: "mini",
                                        type: "danger",
                                        circle: "",
                                        icon: "el-icon-delete"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.removeDomain(domain)
                                        }
                                      }
                                    })
                                  : _c("div"),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addItem(index)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("addItem")) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "itemBox" },
                      _vm._l(domain.item_list, function(domains, indexs) {
                        return _c(
                          "div",
                          { key: indexs, staticClass: "lodingItem" },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0px" },
                                attrs: {
                                  prop:
                                    "desc." +
                                    index +
                                    ".item_list." +
                                    indexs +
                                    ".item_id",
                                  rules: _vm.rules.item_id
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: {
                                    type: "number",
                                    placeholder: _vm.$t("pleaseEnterItemId")
                                  },
                                  model: {
                                    value: domains.item_id,
                                    callback: function($$v) {
                                      _vm.$set(domains, "item_id", _vm._n($$v))
                                    },
                                    expression: "domains.item_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0px" },
                                attrs: {
                                  prop:
                                    "desc." +
                                    index +
                                    ".item_list." +
                                    indexs +
                                    ".item_num",
                                  rules: _vm.rules.item_num
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: {
                                    type: "number",
                                    placeholder: _vm.$t("quantity")
                                  },
                                  model: {
                                    value: domains.item_num,
                                    callback: function($$v) {
                                      _vm.$set(domains, "item_num", _vm._n($$v))
                                    },
                                    expression: "domains.item_num"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0px" },
                                attrs: {
                                  prop:
                                    "desc." +
                                    index +
                                    ".item_list." +
                                    indexs +
                                    ".quality"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: { placeholder: _vm.$t("quality") },
                                  model: {
                                    value: domains.quality,
                                    callback: function($$v) {
                                      _vm.$set(domains, "quality", _vm._n($$v))
                                    },
                                    expression: "domains.quality"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0px" },
                                attrs: {
                                  prop:
                                    "desc." +
                                    index +
                                    ".item_list." +
                                    indexs +
                                    ".star"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: _vm.$t("star") },
                                  model: {
                                    value: domains.star,
                                    callback: function($$v) {
                                      _vm.$set(domains, "star", _vm._n($$v))
                                    },
                                    expression: "domains.star"
                                  }
                                })
                              ],
                              1
                            ),
                            domain.item_list.length > 1
                              ? _c("el-button", {
                                  staticStyle: { margin: "10px 0 10px 20px" },
                                  attrs: {
                                    size: "mini",
                                    type: "danger",
                                    circle: "",
                                    icon: "el-icon-delete"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.removeItem(index, indexs)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                )
              })
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.hiad()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("reset")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "", loading: _vm.issubmit },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("submit")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }